import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  ResponsiveContainer,
} from 'recharts';
import { ChartContainer, ChartConfig } from '@/components/ui/chart';

const chartConfig: ChartConfig = {
  count: { label: 'عدد التوصيلات', color: 'hsl(217, 91%, 60%)' },
};

interface Props {
  data: { hour: number; count: number }[];
}

function hourLabel(h: number) {
  if (h === 0) return '12ص';
  if (h < 12) return `${h}ص`;
  if (h === 12) return '12م';
  return `${h - 12}م`;
}

export function HourlyDistributionChart({ data }: Props) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-[220px] text-muted-foreground text-sm">
        لا توجد بيانات
      </div>
    );
  }

  const max = Math.max(...data.map((d) => d.count));

  return (
    <ChartContainer config={chartConfig} className="h-[220px] w-full">
      <BarChart data={data} margin={{ top: 4, right: 8, left: -16, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border/40" />
        <XAxis dataKey="hour" tickFormatter={hourLabel} tick={{ fontSize: 9 }} interval={1} />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip
          contentStyle={{ background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: 8, fontSize: 12 }}
          labelFormatter={(h) => `${hourLabel(Number(h))} - ${hourLabel(Number(h) + 1)}`}
          formatter={(v: any) => [v, 'توصيلة']}
        />
        <Bar dataKey="count" radius={[3, 3, 0, 0]}>
          {data.map((entry, i) => (
            <Cell
              key={i}
              fill={`hsl(217, 91%, ${40 + Math.round((entry.count / (max || 1)) * 25)}%)`}
            />
          ))}
        </Bar>
      </BarChart>
    </ChartContainer>
  );
}
